import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {apiQuery} from "../../utils/AppConfig";
import {Response} from "../../types/response/Response";
import {OrderTypeDTO} from "../../types/order/OrderTypeDTO";

export const orderApi = createApi({
    reducerPath: 'orderUrl',
    baseQuery: apiQuery,
    tagTypes: ['orderUrl'],
    endpoints: builder => ({
        getOrderTypes: builder.query<Response<OrderTypeDTO[]>, void>({
            query: () => ({
                url: `/orders/types`,
                method: 'GET'
            }),
            providesTags: ['orderUrl']
        })
    })
})

export const {
    useGetOrderTypesQuery
} = orderApi
